import { useTheme as useEmotionTheme } from "@emotion/react";
import { theme } from "../theme";

const useTheme = () => useEmotionTheme() as typeof theme;

export { useTheme };
